/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
class CorpYears extends React.PureComponent {
    static propTypes = {
        onMouseMove: PropTypes.func,
    };

    constructor() {
        super();
        this.yearsList = [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011, 2010, 2009];
    }

    render() {
        const { onMouseMove } = this.props;

        return (
            <div className={styles.newsNav}>
                {this.yearsList.map((item, index) => {
                    if (index < 5) {
                        return (
                            <a
                                className={styles.newsSpec}
                                target="_blank"
                                data-id={`${`year_${item.toString().substring(2)}`}`}
                                onMouseMove={() => onMouseMove(index)}
                                key={index}>
                                {item}
                            </a>
                        );
                    } else if (index >= 5) {
                        return (
                            <a
                                className={styles.newsSpec}
                                data-id={`${`year_${item.toString().substring(2)}`}`}
                                href="//www.ifeng.com/corp/about/sound/2014year/list_0/1.shtml"
                                target="_blank"
                                onMouseMove={() => onMouseMove(index)}
                                key={index}>
                                {item}
                            </a>
                        );
                    }
                })}
            </div>
        );
    }
}

export default CorpYears;
